/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, Directive, EventEmitter, Output} from '@angular/core';
export class StackView {
/**
 * Undocumented experimental feature: inline editing.
 */
editable: boolean = false;

     save: EventEmitter<void> = new EventEmitter<void>(false);
private _editMode: boolean = false;

    editingChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);
/**
 * @return {?}
 */
get editing(): boolean {
        return this.editable && this._editMode;
    }
/**
 * @param {?} value
 * @return {?}
 */
set editing(value: boolean) {
        if (this.editable) {
            this._editMode = value;
            this.editingChange.emit(value);
            if (!value) {
                this.save.emit(null);
            }
        }
    }
/**
 * End of undocumented experimental feature.
 */
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-stack-view",
    template: `
        <ng-content select="clr-stack-header"></ng-content>
        <dl class="stack-view"><ng-content></ng-content></dl>
    `,
    // Custom elements are inline by default.
    styles: [`
        :host { display: block; }
    `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'save': [{ type: Output, args: ["clrStackSave", ] },],
};
}

function StackView_tsickle_Closure_declarations() {
/**
 * End of undocumented experimental feature.
 * @type {?}
 */
StackView.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StackView.ctorParameters;
/** @type {?} */
StackView.propDecorators;
/**
 * Undocumented experimental feature: inline editing.
 * @type {?}
 */
StackView.prototype.editable;
/** @type {?} */
StackView.prototype.save;
/** @type {?} */
StackView.prototype._editMode;
/** @type {?} */
StackView.prototype.editingChange;
}

export class StackViewCustomTags {
    // No behavior
    // The only purpose is to "declare" the tag in Angular
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-stack-label, clr-stack-content"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StackViewCustomTags_tsickle_Closure_declarations() {
/** @type {?} */
StackViewCustomTags.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StackViewCustomTags.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
